import api from "@/modules/clients/services/api";
import rolesApi from "@/modules/acl/roles/services/api";
import organizationsApi from "@/modules/organizations/services/api";
import _ from "lodash";

export default {
  namespaced: true,
  actions: {
    changePassword: async function ({ commit }, payload) {
      await api.changePassword(payload).then((response) => response.data);
    },
    getCurrentClient: async function () {
      return await api.getCurrentClient().then((response) => response.data);
    },
    updateCurrentUser: async function ({ commit }, payload) {
      return await api
        .updateCurrentUser(payload)
        .then((response) => response.data);
    },
    getRoles: async function ({ commit }, payload) {
      return await rolesApi.getItems(payload).then((response) => response.data);
    },
    getItems({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "roles,organizations" })
        .then((response) => {
          return {
            items: response.data.items,
            totalCount: response.data.count,
          };
        });
    },
    getOrganizations: async function ({ commit }, payload) {
      return await organizationsApi
        .getUserOrgItems(payload)
        .then((response) => response.data);
    },
    getUsers: async function ({ commit }, payload) {
      return await api.getItems(payload).then((response) => response.data);
    },
    getBilling: async function ({ commit }) {
      return await api.getBilling().then((response) => response.data);
    },
    async impersonate({ commit }, userId) {
      return api.impersonate(userId)
    },

    async stopImpersonation({ commit }) {
      return api.stopImpersonation()
    }
  },
};
